var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUnknowPilot2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 86,
    viewBox: "0 0 85 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 82,
    height: 83,
    rx: 18.5,
    stroke: "white",
    strokeWidth: 3,
    strokeDasharray: "6 6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.6363 49.696V47.744C35.6363 46.9333 35.8283 46.208 36.2123 45.568C36.5963 44.928 37.1083 44.416 37.7483 44.032C38.4096 43.648 39.1243 43.456 39.8923 43.456H47.8923C48.0416 43.456 48.1696 43.4027 48.2763 43.296C48.4043 43.168 48.4683 43.0293 48.4683 42.88V37.408C48.4683 37.2373 48.4043 37.0987 48.2763 36.992C48.1696 36.864 48.0416 36.8 47.8923 36.8H32.1483V32.96H47.9883C48.7776 32.96 49.4923 33.1627 50.1323 33.568C50.7936 33.952 51.3163 34.464 51.7003 35.104C52.1056 35.744 52.3083 36.4693 52.3083 37.28V43.008C52.3083 43.776 52.1056 44.4907 51.7003 45.152C51.3163 45.792 50.7936 46.3147 50.1323 46.72C49.4923 47.104 48.7776 47.296 47.9883 47.296H40.0523C39.9029 47.296 39.7643 47.36 39.6363 47.488C39.5296 47.5947 39.4763 47.7227 39.4763 47.872V49.696H35.6363ZM35.6363 56V52.192H39.4763V56H35.6363Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnknowPilot2);
export default __webpack_public_path__ + "static/media/unknow-pilot2.d8335785feb35c01c603ed917821a75c.svg";
export { ForwardRef as ReactComponent };